import { render, staticRenderFns } from "./BookingOnline.vue?vue&type=template&id=d85a8cd4&lang=pug&"
import script from "./BookingOnline.vue?vue&type=script&lang=ts&"
export * from "./BookingOnline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports